<template>
  <Layout>
    <DetailForm
      title="Edit"
      description="This form will edit a teammate"
      action="Save"
      @handleCancel="$router.go(-1)"
      @handleAction="handleSubmit"
    >
      <TeammateForm v-if="showEdit" :modelValue="contact" @update:modelValue="updateContact" />
    </DetailForm>
  </Layout>
</template>

<script>
import Layout from '../Layout/index.vue';
import DetailForm from '../shared/DetailForm.vue';
import TeammateForm from './TeammateForm.vue';

export default {
  props: ['record'],
  components: {
    Layout,
    DetailForm,
    TeammateForm,
  },
  data() {
    return {
      contact: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        reLicenseNumber: '',
      },
      showEdit: false,
    };
  },
  mounted() {
    this.getContact();
  },
  methods: {
    updateContact(value) {
      this.contact = value;
    },
    getContact() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/team/${self.$route.params.id}`)
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          self.contact.name = data.record.name;
          self.contact.firstName = data.record.first_name;
          self.contact.lastName = data.record.last_name;
          self.contact.phone = data.record.phone_number;
          self.contact.email = data.record.email;
          self.contact.reLicenseNumber = data.record.re_license_number;
          self.showEdit = true;
        });
    },
    handleSubmit() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/team/${self.$route.params.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          first_name: self.contact.firstName,
          last_name: self.contact.lastName,
          phone_number: self.contact.phone,
          email: self.contact.email,
          stage: self.contact.stage,
          re_license_number: self.contact.reLicenseNumber,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(async data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            await self.$router.push(`/team/${self.$route.params.id}`);
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Teammate edited',
              alertDescription: 'Your Teammate was successfully edited.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Teammate edit error',
              alertDescription: data.message,
            });
          }
        });
    },
    handleCancel() {
      this.$emit('handleContactEditCancel');
    },
  },
};
</script>
